import { useMsal } from "@azure/msal-react";
import React, { useState } from "react";
import apiCall from "../scripts/apiCall";

const Tst = () => {
  const [state, setState] = useState("fail");
  const [state2, setState2] = useState("fail");
  const { instance, accounts } = useMsal();
  if (state === "fail") {
    apiCall(
      "WeatherForecast",
      {},
      (json) => {
        console.log(json);

        setState(json.map((el) => el.summary).join(", ") + "<br>SUCCES");
      },
      instance,
      accounts
    );
  }
  if (state2 === "fail") {
    apiCall(
      "Quote/GetShipInco",
      {},
      (json) => {
        console.log(json);
        setState2(
          json
            .map((el) => "{" + el.name + "<=>" + el.description + "}")
            .join(", ") + "<br>SUCCES"
        );
      },
      instance,
      accounts
    );
  }
  return (
    <>
      <h1>{state}</h1>
      <p>inco ship</p>
      <p>{state2}</p>
    </>
  );
};
export default Tst;
